import PropTypes from "prop-types";
import React from "react";

import { Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

/**
 * OvernightIndicator is a badge to indicate that the flight has overnight connection. Any connection that arrives before 4am
 * and departs after 4am. With the max connection time being 6 hrs and the minimum connection time being whatever the rule for
 * that airport is.
 */

export const OvernightIndicator = (props) => {
  const { className } = props;

  return <Text {...getProps()}>{i18n("OvernightIndicator__TEXT")}</Text>;

  function getProps() {
    return {
      "aria-label": i18n("OvernightIndicator__TEXT_ARIA"),
      className,
      color: "overnight-indicator",
      prefixIcon: "NextDay",
    };
  }
};

OvernightIndicator.propTypes = {
  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,
};
